import React from 'react';
import { compose } from 'recompose';

import { createStyles } from '@material-ui/core/styles';
import { ComponentBaseProps, RouterOutlet, withBaseProps } from '@topconagriculture/react-components';
import { getThemeByTenantId, TapTheme } from '@topconagriculture/theme';

import { config } from '../config';
import { publicRoutesConfig } from './PublicRouterRoutes';
import { getRoutesByUserPersonas } from '../core/helpers/utils/utils';
import { ErrorBoundary } from './ErrorBoundary';

const notificationsIconsStyle = getThemeByTenantId(config.TENANT_ID).notificationsIconsStyle;

export interface AppProps {}

export interface AppPrivateProps extends ComponentBaseProps<typeof styles>, AppProps {}

const styles = (theme: TapTheme) =>
  createStyles({
    '@global': {
      '*': {
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
      },
      a: {
        textDecoration: 'none',
      },
      html: {
        height: '100%',
      },
      body: {
        color: theme.color.font.dark,
        fontFamily: theme.font.family,
        backgroundColor: theme.color.background.body,
        height: '100%',
        margin: 0,
      },
      '.product-description': {
        fontSize: theme.font.size.medium,
        lineHeight: theme.font.lineHeight.mediumBig,

        '&.product-description-card .detail-only': {
          display: 'none',
        },

        '&.product-description-modal .banner': {
          maxWidth: '100%',
        },

        '&.product-description-card .banner': {
          marginTop: theme.space.margin.default,
          maxWidth: '100%',
        },

        '& H1': {
          margin: 0,
          fontSize: theme.font.size.title,
          color: theme.color.font.dark,
          lineHeight: theme.font.lineHeight.small,
          marginBottom: theme.space.margin.default,
        },
        '& P': {
          margin: `${theme.space.margin.smallest}px 0`,
        },
        '& UL': {
          listStyle: 'none',
          listStylePosition: 'inside',
          padding: `${theme.space.padding.smallest}px 0`,
        },
        '& LI': {
          paddingLeft: theme.space.padding.large,
          lineHeight: theme.font.lineHeight.big,
          margin: theme.space.margin.small,
          background: `url(${config.RESOURCES_BASE_URL}/assets/images/market/common/circle-check-green.svg) no-repeat 0 center`,
          backgroundSize: '16px 16px',
        },
      },
      ...(notificationsIconsStyle as any),
    },
  });

export const PublicRouter: React.FunctionComponent<AppPrivateProps> = () => (
  <ErrorBoundary>
    <RouterOutlet routes={getRoutesByUserPersonas(publicRoutesConfig)} />
  </ErrorBoundary>
);

export default compose<AppPrivateProps, AppProps>(withBaseProps({ styles }))(PublicRouter);
